var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterBird(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.25 20c0 10.631-8.619 19.25-19.25 19.25S.75 30.631.75 20 9.369.75 20 .75 39.25 9.369 39.25 20Z",
    stroke: "#757575",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 14.775a7.23 7.23 0 0 1-2.121.597 3.78 3.78 0 0 0 1.623-2.095 7.297 7.297 0 0 1-2.345.92A3.645 3.645 0 0 0 24.462 13c-2.04 0-3.693 1.696-3.693 3.787 0 .297.033.586.096.862-3.07-.157-5.79-1.665-7.612-3.957-.317.56-.5 1.21-.5 1.905a3.81 3.81 0 0 0 1.643 3.151 3.616 3.616 0 0 1-1.673-.473v.047c0 1.835 1.273 3.366 2.963 3.713a3.608 3.608 0 0 1-1.668.066c.47 1.504 1.834 2.6 3.45 2.63A7.29 7.29 0 0 1 12 26.299 10.267 10.267 0 0 0 17.66 28c6.793 0 10.507-5.77 10.507-10.774 0-.165-.004-.328-.01-.49A7.623 7.623 0 0 0 30 14.776Z",
    fill: "#757575"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBird);
export default __webpack_public_path__ + "static/media/twitter-bird.db52fdc45fbaaef14fd81ecba7313eb0.svg";
export { ForwardRef as ReactComponent };